import { Modal } from "antd";
import React from "react";

type FaqProps = {
  visible: boolean;
  onHandleOk: () => void;
  onCancel: () => void;
};

const RecruitmentTermsModal: React.FC<FaqProps> = ({ visible, onCancel }) => {
  return (
    <div>
      <Modal
        title=""
        centered
        open={visible}
        onCancel={onCancel}
        bodyStyle={{ backgroundColor: "rgba(1, 9, 37, 0.83)" }}
        width={1000}
        footer={null}
      >
        <div className="bg-[#fff] h-full font-abel px-2">
          <div className="w-full">
            <h2 className="text-lg md:text-4xl font-[700] pb-3">
              TERMS AND CONDITIONS
            </h2>
            <ol className="privacy-list2 text-[15px] md:text-[20px] text-[#000000] mb-4">
              <li className="pb-3">
                <b className="font-[900] pb-2">Quotes and Salary Estimates</b>
                <br />
                <span>
                  All quotes and salary rates, derived from industry and market
                  research, are valid for 30 days. Actual salaries may vary due
                  to market fluctuations, and alignment with projected figures
                  is not guaranteed. The final invoice will reflect the
                  candidate's accepted offer.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">
                  Search Timeline and Scope Adjustments{" "}
                </b>
                <br />
                <span>
                  25th and Staffing reserves the right to adjust recruitment
                  timelines if the client modifies the initial terms,
                  conditions, or scope of the search. We are not responsible for
                  dissatisfaction, performance issues, or turnover after a
                  candidate has been hired. If the client hires a candidate
                  despite known concerns, the client assumes full responsibility
                  for any resulting issues.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Information Accuracy</b>
                <br />
                <span>
                  The client must provide complete and accurate information
                  regarding the job role, workplace conditions, and any material
                  factors necessary for candidate assessment. 25th and Staffing
                  is not liable for outcomes arising from inaccurate,
                  incomplete, or withheld information.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Candidate Recommendations </b>
                <br />
                <span>
                  While 25th and Staffing aim to recommend qualified candidates,
                  we do not guarantee placement or performance. Candidate
                  suitability and selection remain at the client's discretion.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Fees and Additional Services </b>
                <br />
                <span>
                  The retainer fee covers the recruitment services outlined in
                  the engagement. Any additional services, such as multiple
                  replacements, extended searches, or post-placement support,
                  will incur additional charges, which must be agreed to in
                  writing.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Limitation of Liability </b>
                <br />
                <span>
                  25th and Staffing is not liable for indirect, consequential,
                  or incidental damages, including but not limited to lost
                  profits or business disruption, arising from candidate
                  placement.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Recruitment Fee Enforcement </b>
                <br />
                <span>
                  Any attempt by the client to bypass the recruitment fee
                  through direct engagement with a candidate will result in
                  legal action to recover the full fee, plus costs, including
                  legal expenses, payable immediately, regardless of employment
                  status. Conversely, if 25th and Staffing inflate salaries to
                  increase fees, the client retains the right to pursue legal
                  action.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Offer and Commencement </b>
                <br />
                <span>
                  Candidates may not commence employment until the offer is
                  formally extended and accepted.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Payment Terms </b>
                <br />
                <span>
                  All payments are due within 5 business days of the signed
                  offer. Late payments may result in suspension of offers across
                  multiple orders, voided replacement guarantees, rebates, and
                  allow staged invoicing for unsettled orders. 25th and Staffing
                  is not responsible for restarting recruitment if the client
                  delays sending the offer letter post-selection.
                </span>
              </li>
              <li className="pb-3">
                <b className="font-[900] pb-2">Delivery Timelines </b>
                <br />
                <span>
                  We adhere to agreed delivery timelines and will notify the
                  client in advance of any delays, expecting the same courtesy
                  in return. For specialized or niche roles, we may be unable to
                  provide multiple candidates or replacements due to market
                  constraints.
                </span>
              </li>
            </ol>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RecruitmentTermsModal;
